export const parkingConstants = {
    START_UPDATE_PARKING: `START_UPDATE_PARKING`,
    SET_PARKING_SUCCESS: `SET_PARKING_SUCCESS`,
    SET_PARKING_FAILURE: `SET_PARKING_FAILURE`,
    RESET_PARKING: `RESET_PARKING`,
}
